// helper function to group objects of an array based on status key with possible values defined in constants array
export function HHoldMTFGroupBy(array: Array<any>, key: string = "mtfRmsHdg"): Array<Array<any>> {
	//return 2d array with conditinal grouping
	const grouped: Array<Array<any>> = array.reduce(
		(arr: any, d: any) => {
			if (d[key]) {
				arr[0] = [...arr[0], d];
			} else {
				arr[1] = [...arr[1], d];
			}
			return arr;
		},
		[[], []]
	);

	// if any group is empty then remove it from the array
	return grouped.filter(group => group.length);
}

export function HHoldDematGroupBy(array: Array<any>, key: string = "mode"): Array<Array<any>> {
	//return 2d array with conditinal grouping
	const grouped: Array<Array<any>> = array.reduce(
		(arr: any, d: any) => {
			if (d[key] === "D") {
				arr[0] = [...arr[0], d];
			} else {
				arr[1] = [...arr[1], d];
			}
			return arr;
		},
		[[], []]
	);

	// if any group is empty then remove it from the array
	return grouped.filter(group => group.length);
}
